// import React from "react";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";

// const TermsPage = () => {
//   return (
//     <div className="min-h-screen bg-gradient-to-b from-[#CBCECE] to-[#77D8EE]">
//       <Navbar />

//       <div className="pt-32 pb-16 px-4 max-w-4xl mx-auto">
//         <div className="bg-white rounded-lg shadow-lg p-8">
//           <h1 className="text-4xl font-bold text-gray-800 mb-4 text-center">
//             Plutonic Terms of Service
//           </h1>
//           <p className="text-center text-gray-600 mb-8">
//             Last Updated: August 11th, 2025
//           </p>

//           <div className="text-gray-700 space-y-6">
//             {/* Important Legal Notice */}
//             <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6">
//               <div className="flex">
//                 <div className="flex-shrink-0">
//                   <svg
//                     className="h-5 w-5 text-red-400"
//                     viewBox="0 0 20 20"
//                     fill="currentColor"
//                   >
//                     <path
//                       fillRule="evenodd"
//                       d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
//                       clipRule="evenodd"
//                     />
//                   </svg>
//                 </div>
//                 <div className="ml-3">
//                   <h3 className="text-sm font-medium text-red-800">
//                     IMPORTANT LEGAL NOTICE
//                   </h3>
//                   <p className="text-sm text-red-700 mt-1">
//                     These Terms of Service include a binding individual arbitration agreement and a class action waiver. This affects your rights in the event of a dispute with Plutonic, Inc. Please read carefully. You have the right to opt out — see Section 10 for more details.


//                   </p>
//                 </div>
//               </div>
//             </div>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 1. Using Our Services
//               </h2>

//               <h3 className="text-xl font-medium text-gray-700 mb-3">
//                 a. Representations and Age Restriction
//               </h3>
//               <ul className="text-gray-600 list-disc list-inside space-y-2 ml-4 mb-4">
//                 <li>All information you submit is truthful and accurate.</li>
//                 <li>
//                   Your use of the Services complies with all applicable laws and
//                   regulations.
//                 </li>
//                 <li>
//                   You are at least 13 years of age and legally competent to
//                   enter into these Terms.
//                 </li>
//                 <li>
//                   You acknowledge that the Services are not a substitute for
//                   in-person medical or mental health evaluation, diagnosis, or
//                   treatment, and that the Services are intended for
//                   non-emergency use only.
//                 </li>
//               </ul>

//               <h3 className="text-xl font-medium text-gray-700 mb-3">
//                 b. Clinical Services Disclaimer
//               </h3>
//               <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
//                 <p className="text-yellow-800 font-semibold mb-2">
//                   DO NOT USE OUR SERVICES FOR EMERGENCIES.
//                 </p>
//                 <p className="text-yellow-700">
//                   Plutonic is not an emergency or crisis service. If you are
//                   experiencing a crisis, suicidal thoughts, or are a danger to
//                   yourself or others, please call 911 (or your local emergency
//                   number).
//                 </p>
//               </div>
//               <p className="text-gray-600 leading-relaxed mb-4">
//                 Plutonic facilitates access to independent therapists or
//                 licensed professionals ("Therapists") via its technology
//                 platform and through traditional in-person therapy sessions.
//                 These individuals are not employees, agents, or representatives
//                 of Plutonic.
//               </p>
//               <p className="text-gray-600 leading-relaxed mb-4">
//                 You understand and agree:
//               </p>
//               <ul className="text-gray-600 list-disc list-inside space-y-2 ml-4 mb-4">
//                 <li>
//                   Your relationship is solely with the Therapist, not with
//                   Plutonic.
//                 </li>
//                 <li>
//                   Plutonic is not responsible for any part of your interaction
//                   or treatment.
//                 </li>
//                 <li>
//                   Therapy session data may be reviewed for quality control, risk
//                   mitigation, or research purposes, in accordance with HIPAA and
//                   applicable privacy standards.
//                 </li>
//                 <li>
//                   Any medical, mental health, or wellness information provided
//                   by Therapists through the Services is for general
//                   informational purposes only and should not replace
//                   individualized advice from a qualified in-person provider.
//                 </li>
//               </ul>

//               <h3 className="text-xl font-medium text-gray-700 mb-3">
//                 c. Your Plutonic Account
//               </h3>
//               <p className="text-gray-600 leading-relaxed mb-4">
//                 To use Plutonic Services, you must create a user account
//                 ('Account') and provide accurate, up-to-date information. This
//                 includes usage and acceptance of our utilized electronic health
//                 records systems. You are solely responsible for maintaining the
//                 confidentiality of your login credentials and for all activity
//                 conducted under your Account.
//               </p>

//               <h3 className="text-xl font-medium text-gray-700 mb-3">
//                 d. Therapy Services for Minors (Including Children Under 13)
//               </h3>
//               <ul className="text-gray-600 list-disc list-inside space-y-2 ml-4">
//                 <li>
//                   Plutonic provides therapy services to minors only with the
//                   informed consent of a parent or legal guardian.
//                 </li>
//                 <li>
//                   For clients under the age of 18, parental or guardian consent
//                   is required.
//                 </li>
//                 <li>
//                   For clients under the age of 13, Plutonic complies with the
//                   Children's Online Privacy Protection Act (COPPA) and requires
//                   verifiable parental consent prior to creating an account,
//                   collecting personal information, or initiating services.
//                 </li>
//                 <li>
//                   "Verifiable parental consent" may include submission of a
//                   signed consent form, identity verification through secure
//                   video call, payment verification, or other methods permitted
//                   under COPPA.
//                 </li>
//                 <li>
//                   The consenting parent or guardian may be required to
//                   participate in the intake process, and may have full access to
//                   session records unless otherwise limited by law.
//                 </li>
//                 <li>
//                   If consent is withdrawn or cannot be verified, services for
//                   the minor will be discontinued immediately.
//                 </li>
//               </ul>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 2. Prohibited Use of Our Services
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 You agree not to: harass, abuse, threaten, impersonate, disrupt
//                 services, transmit harmful material, or engage in unauthorized
//                 data extraction.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 3. Intellectual Property Rights
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 All content, materials, and software are owned by Plutonic or
//                 its licensors. You are granted a limited, non-exclusive license
//                 for personal, non-commercial use only.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 4. Privacy
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 Your privacy is important to us. Please review our Privacy
//                 Policy to understand how we collect, use, and protect your
//                 information.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 5. Software
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 You may receive automatic updates. You may not tamper with or
//                 reverse-engineer our software.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 6. Warranties and Disclaimers
//               </h2>
//               <p className="text-gray-600 leading-relaxed font-semibold">
//                 PLUTONIC PROVIDES THE SERVICES "AS IS" WITHOUT WARRANTIES OF ANY
//                 KIND.
//               </p>
//               <p className="text-gray-600 leading-relaxed mt-2">
//                 To the fullest extent permitted by law, Plutonic disclaims all
//                 implied warranties, including but not limited to fitness for a
//                 particular purpose, merchantability, and non-infringement.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 7. Limitation of Liability
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 Plutonic's liability is limited to the amounts paid for the
//                 Services.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 8. Indemnity
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 You agree to indemnify and hold harmless Plutonic against claims
//                 arising from your use of the Services.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 9. Copyright and DMCA Policy
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 If you believe your IP rights have been infringed, contact
//                 help@plutonic.co.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 10. Dispute Resolution, Arbitration, and Class Action Waiver
//               </h2>
//               <ul className="text-gray-600 list-disc list-inside space-y-2 ml-4">
//                 <li>
//                   Disputes must first be attempted to be resolved informally
//                   before arbitration.
//                 </li>
//                 <li>
//                   Binding arbitration under JAMS Rules will occur if necessary.
//                 </li>
//                 <li>No class actions permitted.</li>
//                 <li>
//                   Right to opt-out within 30 days by emailing help@plutonic.co.
//                 </li>
//               </ul>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 11. Governing Law and Exclusive Venue
//               </h2>
//               <p className="text-gray-600 leading-relaxed mb-2">
//                 These Terms of Service, and any disputes or claims arising out
//                 of or related to them, are governed by the laws of the State of
//                 Georgia, without regard to conflict of law principles.
//               </p>
//               <p className="text-gray-600 leading-relaxed mb-2">
//                 All applicable federal and state healthcare, telehealth, and
//                 privacy laws (including HIPAA) will apply regardless of your
//                 location.
//               </p>
//               <p className="text-gray-600 leading-relaxed">
//                 If for any reason a dispute proceeds in court rather than in
//                 arbitration, you and Plutonic, Inc. agree to exclusive
//                 jurisdiction and venue in the state and federal courts located
//                 in Fulton County, Georgia.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 12. Termination
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 We may suspend or terminate your access to the Services at our
//                 discretion. Reasons may include violations of these Terms, abuse
//                 of the Services, or legal/regulatory requirements. Upon
//                 termination, your account and data may be deleted, subject to
//                 applicable record retention laws.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 13. Miscellaneous
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 Entire agreement; severability; no waiver; force majeure
//                 protections.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 14. Contact Us
//               </h2>
//               <div className="text-gray-600">
//                 <p>
//                   <strong>Plutonic, Inc.</strong>
//                 </p>
//                 <p>3295 River Exchange Drive, Suite 567</p>
//                 <p>Norcross, GA 30092</p>
//                 <p>help@plutonic.co</p>
//               </div>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 15. Third-Party Software and Service Providers
//               </h2>
//               <p className="text-gray-600 leading-relaxed mb-4">
//                 Plutonic utilizes secure third-party software to deliver
//                 components of our therapy services, including:
//               </p>
//               <ul className="text-gray-600 list-disc list-inside space-y-2 ml-4 mb-4">
//                 <li>
//                   Teletherapy services (video-based therapy sessions), and
//                 </li>
//                 <li>
//                   Electronic health record (EHR) and clinical documentation
//                   systems.
//                 </li>
//               </ul>
//               <p className="text-gray-600 leading-relaxed">
//                 These third-party providers are selected for their security
//                 practices and HIPAA compliance (where applicable). By using
//                 Plutonic's Services, you acknowledge and agree that your therapy
//                 sessions, notes, communications, and personal information may be
//                 stored, processed, or transmitted through these secure
//                 third-party systems. Plutonic remains committed to protecting
//                 your privacy and confidentiality through appropriate contractual
//                 and technical safeguards.
//               </p>
//             </section>

//             <div className="mt-8 p-4 bg-gray-50 rounded-lg">
//               <p className="text-sm text-gray-500 text-center">
//                 Last updated: August 11th, 2025
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default TermsPage;


import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#CBCECE] to-[#77D8EE]">
      <Navbar />

      <div className="pt-32 pb-16 px-4 max-w-4xl mx-auto">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-4xl font-bold text-gray-800 mb-4 text-center">
          Plutonic Terms of Service
        </h1>
        <p className="text-center text-gray-600 mb-8">
          Last Updated: August 11th, 2025
        </p>

        <div className="text-gray-700 space-y-8">
          {/* Important Legal Notice */}
          <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg
                  className="h-5 w-5 text-red-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">
                  IMPORTANT LEGAL NOTICE
                </h3>
                <p className="text-sm text-red-700 mt-1">
                  These Terms of Service include a binding individual
                  arbitration agreement and a class action waiver. This affects
                  your rights in the event of a dispute with Plutonic, Inc.
                  Please read carefully. You have the right to opt out — see
                  Section 10 for more details.
                </p>
              </div>
            </div>
          </div>

          {/* Section 1 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              1. Welcome to Plutonic
            </h2>
            <p className="text-gray-700 mb-4">
    Thanks for choosing Plutonic. These Terms of Service (“Terms”) outline the
    agreement between you (“you” or “User”) and Plutonic, Inc. (“Plutonic,”
    “we,” “us,” or “our”).
  </p>

  <p className="text-gray-700 mb-2">
    These Terms apply whenever you access or use:
  </p>

  <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>
      Our websites at{" "}
      <a
        href="https://www.plutonic.co"
        className="text-blue-600 hover:underline"
      >
        https://www.plutonic.co
      </a>{" "}
      and{" "}
      <a
        href="https://www.aiplutonic.co"
        className="text-blue-600 hover:underline"
      >
        https://www.aiplutonic.co
      </a>{" "}
      (collectively, the “Sites”),
    </li>
    <li>Our AI Mental Health Companion platform (the “Companion”), and</li>
    <li>
      Any features, content, or services we provide in connection with the
      Companion (collectively, the “Services”).
    </li>
  </ul>

  <p className="mt-4 text-gray-700">
    By using our Services or affirmatively accepting these Terms, you are
    entering into a legally binding agreement with Plutonic. If you do not
    agree, you may not use the Services.
  </p>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              2. Eligibility and Age Restriction
            </h2>
            <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>
      You must be 18 years of age or older and a resident of Georgia, USA to use the Companion at this time.
    </li>
    <li>
      By using the Services, you represent and warrant that all information you submit is truthful and accurate, and that your use of the Services complies with all applicable laws and regulations.

​
    </li>
    
  </ul>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              3. Nature of Services – Important Disclaimers
            </h2>
            <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>
      The Companion is an AI-powered mental health wellness tool designed to
      support reflection, stress management, and skill-building.
    </li>
    <li>
      The Companion is not a licensed therapist, not clinical monitoring, not
      therapy, and not medical advice.
    </li>
    <li>
      The Companion should not be relied upon for diagnosis, treatment, or as a
      substitute for professional mental health or medical care.
    </li>
    <li>
      Plutonic does not provide medical services, crisis services, or emergency
      intervention.
    </li>
  </ul>
  <p className="mt-3 text-gray-700">
    If you need professional mental health treatment, you should seek care from
    a licensed provider.
  </p>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              4. Emergency Safeguards Disclaimer
            </h2>
             <p className="text-gray-700 mb-4">
    The Companion includes automated safety features designed to pause or stop
    interactions if a user mentions self-harm, harm to others, or requests
    medical advice. These features are provided “as is” and without guarantee of
    performance.
  </p>

  <p className="text-gray-700 mb-2">You acknowledge and agree that:</p>

  <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>
      The Companion’s safeguards may not detect or respond to all crisis
      language.
    </li>
    <li>
      The Companion is not a replacement for crisis services, medical care, or
      human intervention.
    </li>
    <li>
      You remain solely responsible for seeking appropriate help in the event of
      an emergency.
    </li>
    <li>
      Plutonic, Inc. is not liable for any harm, damages, or losses that occur
      if the Companion fails to detect or respond to emergency or
      crisis-related content.
    </li>
  </ul>

  <p className="mt-4 text-gray-700 font-medium">
    If you are experiencing a crisis or thinking of harming yourself or others,
    call 988 in the U.S., 911, or your local emergency number immediately.
  </p>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              5. Prohibited Use of the Services
            </h2>
            <p className="text-gray-700 mb-2">You agree not to use the Services to:</p>

  <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>Harass, abuse, threaten, impersonate, or harm others.</li>
    <li>Transmit harmful, illegal, or offensive material.</li>
    <li>
      Attempt to use the Companion for medical, diagnostic, or crisis purposes.
    </li>
    <li>
      Reverse-engineer, modify, or interfere with the functioning of the
      Services.
    </li>
  </ul>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              6. Privacy and Data Use
            </h2>
            <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>Your interactions are private, encrypted, and never sold to third parties.</li>
    <li>
      Interaction data may be de-identified and aggregated to improve moderation,
      safety, and quality.
    </li>
    <li>
      If you use the Companion in between sessions with a licensed therapist,
      your therapist may access your interaction history as part of your care. In
      this case, the data is treated as Protected Health Information (PHI) and
      handled in compliance with HIPAA and Georgia privacy laws.
    </li>
    <li>
      For more details, please see our{" "}
      <a href="/privacy" className="text-blue-600 hover:underline">
        Privacy Policy
      </a>
      .
    </li>
  </ul>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              7. Intellectual Property Rights
            </h2>
            <p className="text-gray-700">
             All content, software, designs, and materials are owned by Plutonic or its licensors. You are granted a limited, non-exclusive license for personal, non-commercial use only.


            </p>
          </section>

          {/* Section 8 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              8. Warranties and Disclaimers
            </h2>
            <p className="font-semibold text-gray-700">
              PLUTONIC PROVIDES THE SERVICES “AS IS” WITHOUT WARRANTIES OF ANY
              KIND.
            </p>
            <p className="mt-2 text-gray-700">
              To the fullest extent permitted by law, Plutonic disclaims all
              implied warranties, including but not limited to fitness for a
              particular purpose, merchantability, and non-infringement.
            </p>
          </section>

          {/* Section 9 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              9. Limitation of Liability
            </h2>
            <p className="text-gray-700 mb-2">To the maximum extent permitted by law:</p>

  <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>Plutonic’s liability is limited to the amounts you paid for the Services.</li>
    <li>
      Plutonic is not liable for indirect, incidental, special, consequential, or
      punitive damages, including those arising from reliance on the Companion or
      failures of emergency safeguard features.
    </li>
  </ul>
          </section>

          {/* Section 10 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              10. Dispute Resolution, Arbitration, and Class Action Waiver
            </h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Disputes must first be attempted to be resolved informally.</li>
              <li>
                If unresolved, disputes will be settled through binding
                arbitration under JAMS Rules.
              </li>
              <li>No class actions permitted.</li>
              <li>
                You may opt out of arbitration within 30 days of accepting these
                Terms by emailing{" "}
                <a
                  href="mailto:help@plutonic.co"
                  className="text-blue-600 hover:underline"
                >
                  help@plutonic.co
                </a>
                .
              </li>
            </ul>
          </section>

          {/* Section 11 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              11. Governing Law and Venue
            </h2>
            <p className="text-gray-700">
              These Terms are governed by the laws of the State of Georgia,
              without regard to conflict of law principles. If a dispute
              proceeds in court rather than arbitration, you and Plutonic agree
              to exclusive jurisdiction and venue in the state and federal
              courts located in Fulton County, Georgia.
            </p>
          </section>

          {/* Section 12 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              12. Termination
            </h2>
            <p className="text-gray-700">
              We may suspend or terminate your access to the Services at our
              discretion, including for violations of these Terms, abuse of the
              Services, or legal/regulatory requirements. Upon termination, your
              account and data may be deleted, subject to applicable record
              retention laws.
            </p>
          </section>

          {/* Section 13 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              13. Miscellaneous
            </h2>
            <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>These Terms represent the entire agreement between you and Plutonic.</li>
    <li>If any provision is found invalid, the rest remain enforceable.</li>
    <li>No waiver of rights is implied by failure to enforce.</li>
    <li>Force majeure protections apply.</li>
  </ul>
          </section>

          {/* Section 14 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              14. Contact Us
            </h2>
            <div className="text-gray-700">
              <p>
                <strong>Plutonic, Inc.</strong>
              </p>
              <p>3295 River Exchange Drive, Suite 567</p>
              <p>Norcross, GA 30092</p>
              <p>
                <a
                  href="mailto:help@plutonic.co"
                  className="text-blue-600 hover:underline"
                >
                  help@plutonic.co
                </a>
              </p>
            </div>
          </section>

          <div className="mt-8 p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-500 text-center">
              Last updated: August 11th, 2025
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    </div>
  );
};

export default TermsPage;


